import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'clef-bass',
  size: 24,
  node: [
    ['path', { d: 'M19 11h.01', key: '6rud08' }],
    ['path', { d: 'M19 6h.01', key: '1ngg9n' }],
    ['path', { d: 'M5 8c0-4 4-4 4-4 6 0 6 6 6 6 0 7-10 11-10 11', key: '149hcj' }],
    ['circle', { cx: '7', cy: '8', r: '2', key: 'p5re1b' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ClefBass
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgMTFoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xOSA2aC4wMSIgLz4KICA8cGF0aCBkPSJNNSA4YzAtNCA0LTQgNC00IDYgMCA2IDYgNiA2IDAgNy0xMCAxMS0xMCAxMSIgLz4KICA8Y2lyY2xlIGN4PSI3IiBjeT0iOCIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/clef-bass
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ClefBass = createLucideIcon(__iconData);

export default ClefBass;
